import script from "./RegisterPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterPage.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterPage.vue?vue&type=style&index=0&id=36c5cc25&lang=css"

const __exports__ = script;

export default __exports__